import {
    SimpleGrid,
} from "@chakra-ui/react";

import {
    Users,
    BadgeCheck,
    Wallet,
} from "lucide-react";

import StatCard from "../../Dashboard/components/StatCard";

const ReferralStats = ({
    drivers = [],
    milestones = [],
    pendingCommissions = [],
    payouts = [],
}) => {
const approvedDrivers =
    drivers.filter(
        driver =>
            driver.driver
                ?.status ===
            "Approved"
    );




            const paidMilestoneEarnings =
    milestones
        .filter(
            milestone =>
                milestone.commission_status ===
                "Paid"
        )
        .reduce(
            (
                total,
                milestone
            ) =>
                total +
                Number(
                    milestone.commission_amount ||
                        0
                ),
            0
        );

const paidDeliveryEarnings =
    payouts
        .filter(
            payout =>
                payout.commission_id &&
                payout.status === "Paid"
        )
        .reduce(
            (
                total,
                payout
            ) =>
                total +
                Number(
                    payout.amount || 0
                ),
            0
        );

const totalEarned =
    paidMilestoneEarnings +
    paidDeliveryEarnings;

    const pendingMilestoneEarnings =
    milestones
        .filter(
            milestone =>
                milestone.commission_status ===
                "Pending"
        )
        .reduce(
            (
                total,
                milestone
            ) =>
                total +
                Number(
                    milestone.commission_amount ||
                        0
                ),
            0
        );

const pendingDeliveryEarnings =
    pendingCommissions
        .filter(
            commission =>
                commission.record_type ===
                    "COMMISSION" &&
                commission.commission_status ===
                    "Pending"
        )
        .reduce(
            (
                total,
                commission
            ) =>
                total +
                Number(
                    commission.commission_amount ||
                        0
                ),
            0
        );

const pendingCommission =
    pendingMilestoneEarnings +
    pendingDeliveryEarnings;

    return (
        <SimpleGrid
            columns={{
                base: 1,
                lg: 3,
            }}
            gap={6}
            mb={8}
        >
            <StatCard
                title="Total Recruited Drivers"
                value={
                    drivers.length
                }
                subtitle="Drivers recruited through your referral code"
                icon={
                    <Users
                        size={20}
                        color="#2453FF"
                    />
                }
            />

            <StatCard
                title="Approved Drivers"
                value={
                    approvedDrivers.length
                }
                subtitle={`${approvedDrivers.length}/${drivers.length} drivers approved`}
                icon={
                    <BadgeCheck
                        size={20}
                        color="#2453FF"
                    />
                }
            />

            <StatCard
                title="Recruitment Earnings"
                value={`P${totalEarned.toFixed(
                    2
                )}`}
                subtitle={`P${pendingCommission.toFixed(
                    2
                )} pending payout`}
                icon={
                    <Wallet
                        size={20}
                        color="#2453FF"
                    />
                }
                bg="#2453FF"
                color="white"
            />
        </SimpleGrid>
    );
};

export default ReferralStats;